import styled from "@emotion/styled";
import { mq } from "@styles/helpers";
import { Devices } from "@styles/tokens";

export const Grid = styled.div`
    display:grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap:2rem;
    margin-top: 2rem;
`;

export const GridItemCol1 = styled.div`
    padding:1.2rem 1.5rem;
    background:#fff;
    border-radius: 10px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
`;

export const ItemContent = styled.div`
    width:100%;
    height:calc(100% - 26px);
    display:flex;
    flex-direction: column;
    padding-top: 40px;
    align-items: center;

`;

export const LegendWrap = styled.div`
    width:100%;
    margin-top: auto;
    display: flex;
    flex-wrap: wrap;
    gap:0.1rem 1rem;
`;

export const LegendTag = styled.div<{color?:string}>`
    display:flex;
    align-items: center;
    gap:0.8rem;
    font-size: 14px;
    font-weight: 500;
    
    div{
        background:${props => props.color?props.color:"transparent"};
        border-radius: 10px;
        height:8px;
        width:22px;
        content: " ";
    }
`;

export const GridItemCol2 = styled.div`
    grid-column: auto / span 2;
    padding:1.2rem 1.5rem;
    background:#fff;
    border-radius: 10px;
    box-shadow: 0 0 3px rgba(0,0,0,0.25);
    height:450px;
`;

export const GridItemTitle = styled.div`
    width:100%;
    display:flex;
    justify-content:center;
    font-size: 18px;
    font-weight: 500;
`;

export const GridItemTitleLeft = styled.div`
    font-size: 18px;
    font-weight: 500;
    display:flex;
    align-items: center;

    button{
        margin-left: auto;
        font-size: 14px;
        font-weight: 400;
        background:#2A848E;
        color:#fff;
        padding:0.4rem 1rem;
        border-radius: 20px;

        &:hover{
            opacity: 0.8;
        }
    }
`;

export const DataListWrap = styled.div`
    height:350px;
    overflow:auto;  

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
  background-color: darkgrey;
}
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}
scrollbar-width: thin;
`;

export const DashList = styled.table`
    width:100%;
    margin-top: 1rem;
    border-collapse: collapse;

    td{
        font-size: 14px;
        padding:5px 10px;

        &:nth-of-type(1){
            padding:5px 0 5px 10px;
            width:34px;
        }

        &:last-of-type{
            text-align: right;
        }
    }

    tr:nth-of-type(even){
            background:#2a848e20;
    }

    tr:nth-of-type(1){
        font-weight: 600;
    }

    span{
        display:block;
        white-space: nowrap;
    }
`;

export const Img = styled.div`
    width:34px;
    height:34px; 
    position: relative;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 0 2px rgba(0,0,0,0.25);
`;

export const PickButton = styled.button`
    font-size: 12px;
    font-weight: 400;
    background:#2A848E;
    color:#fff;
    padding:0.5rem 1rem;
    border-radius: 20px;
    white-space: nowrap;

    &:hover{
        opacity: 0.8;
    }
`;

export const ActionBar = styled.div`
    display:flex;
    gap:1rem;
    margin-left: auto;
    justify-content: end;

    svg{
        cursor: pointer;
        height:18px;

        :hover{
            opacity: 0.8;
        }
    }
`;